export class assistedModeService {
    constructor(params) {
        this.SingletonWebSocket = params.SingletonWebSocket;
        this.SingletonSharedData = params.SingletonSharedData;
        this.StateRule = params.StateRule;
    }
    exitAssistedMode() {
        const action = "exitAssistedMode";
        if (this.StateRule.validate(this.SingletonSharedData.getCurrentStatus(), action)) {
            const message = { client: "integration", action }
            this.SingletonWebSocket.send(message);
        }
    }
}


// WEBPACK FOOTER //
// ./src/Services/assistedModeService.js